var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.297 11.5406C14.1028 11.227 13.8128 10.9475 13.7104 10.6102C13.6081 10.2716 13.6816 9.87794 13.6816 9.50918C13.6803 8.41209 13.6829 7.315 13.6803 6.21791C13.675 3.53161 11.784 1.22719 9.15279 0.69833C6.02424 0.0697337 2.96525 2.20486 2.49151 5.35441C2.44689 5.64836 2.42589 5.94888 2.42458 6.24678C2.41802 7.64832 2.42327 9.05118 2.41802 10.4527C2.41802 10.5498 2.38521 10.6614 2.3314 10.7441C1.96527 11.3097 1.58995 11.87 1.21594 12.4304C0.866866 12.954 0.814374 13.5025 1.11227 14.0576C1.41147 14.6141 1.90359 14.87 2.52956 14.87C6.20009 14.8713 9.87062 14.8713 13.5425 14.87C14.4125 14.87 14.9821 14.4041 15.1658 13.5445C15.1697 13.5288 15.1842 13.5157 15.1934 13.5012C15.1934 13.3844 15.1934 13.2663 15.1934 13.1495C15.0634 12.5209 14.6212 12.0629 14.297 11.5406Z",
    stroke: "#005555",
    strokeWidth: 1.11
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40176 17.8915C7.54481 17.9374 7.6931 17.9637 7.84008 18.0004C7.98049 18.0004 8.12222 18.0004 8.26264 18.0004C8.28888 17.9899 8.31382 17.9715 8.34138 17.9689C8.80987 17.9125 9.21538 17.7183 9.56445 17.4046C9.84003 17.1553 10.0434 16.8574 10.1655 16.4978C8.74557 16.4978 7.34796 16.4978 5.93066 16.4978C6.21019 17.2038 6.69443 17.6658 7.40176 17.8915Z",
    stroke: "#005555",
    strokeWidth: 1.11
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.67e3a0a7035ea3de8ea36d944bd06bc6.svg";
export { ForwardRef as ReactComponent };